import React, { useRef } from 'react';
import { StyledHeroProducts } from './StyledHeroProducts';


const HeroProducts = ({ title, imgLeft, imgRight }) => {
  const titleRef = useRef(null);

  return (
    <React.Fragment>
      {
       
          <StyledHeroProducts>
            <div className="industries--hero-bg" ></div>
            <h4 ref={titleRef} className="big--title">{title}</h4> 
            <img className="left" src={imgLeft} />
            <img className="right" src={imgRight} />
          </StyledHeroProducts>
          
      }
    </React.Fragment>
  );
};

export default HeroProducts;
